import { parseFitFile } from './fit-ride';
import type { RideImportChoice, XmlRideFormat } from './ride-import-choice';
import type { Ride } from './ride';

export type RideImportResult = { readonly kind: 'ride'; readonly ride: Ride; readonly warnings?: readonly string[] }
  | { readonly kind: 'tracks'; readonly format: XmlRideFormat; readonly tracks: readonly RideImportChoice[] };

/** Dispatches supported local files without trusting their MIME type. */
export async function parseRideFile(file: File): Promise<RideImportResult> {
  if (/\.fit$/iu.test(file.name)) return { kind: 'ride', ride: await parseFitFile(file) };
  const format = /\.gpx$/iu.test(file.name) ? 'gpx' : /\.tcx$/iu.test(file.name) ? 'tcx' : undefined;
  if (!format) throw new Error('Choose a FIT or GPX trace file.');
  const tracks = format === 'gpx'
    ? await (await import('./gpx-ride')).parseGpxFile(file)
    : await (await import('./tcx-ride')).parseTcxFile(file);
  if (tracks.length > 1) return { kind: 'tracks', format, tracks };
  const track = tracks[0]!;
  if (!track.ride) throw new Error(track.error);
  return { kind: 'ride', ride: track.ride, ...(track.warnings ? { warnings: track.warnings } : {}) };
}
